var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8266 16.1059C22.2769 16.9052 22.8044 18.7303 22.0055 20.1799C21.4441 21.1985 20.3776 21.7486 19.2904 21.7176L19.293 21.7285L8.00016 21.7556L17.8008 16.1832L17.8044 16.1955C18.696 15.6448 19.8438 15.5642 20.8266 16.1059Z",
    fill: "#36ACD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72002 4.65726C9.7931 1.97134 13.7638 0.256342 18.3008 0V4.55745C14.5199 4.79791 12.2922 5.99871 10.0555 7.8725L6.72002 4.65726Z",
    fill: "#b5e1f5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57989 17.5269H0.0277341C0.333227 12.9899 2.10796 9.26196 4.86345 6.20703L8.08398 9.40791C6.14365 11.631 4.86723 14.5022 4.57989 17.5269Z",
    fill: "#b5e1f5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55999 19.7943C5.04167 27.356 11.3066 33.3532 18.959 33.3532C26.9253 33.3532 33.6446 26.8925 33.6446 18.927C33.6446 11.3441 27.3767 5.1397 20.5712 4.55745V0C30.4014 0.589058 38.1816 8.86006 38.1816 18.9466C38.1816 29.4143 29.5462 37.8902 19.0785 37.8902C8.92158 37.8902 0.484221 29.6245 -0.000484467 19.7943H4.55999Z",
    fill: "#36ACD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedOne);
export default __webpack_public_path__ + "static/media/SpeedOne.076b79d3f8cb283e134e4c695cfb9316.svg";
export { ForwardRef as ReactComponent };